export const boards = [
  {
    id: "today",
    name: "今日话题",
    icon: "ri-sun-line",
    desc: "每天一个开放话题，谁都能接一句，看看大家的脑回路有多野。",
    topics: 12480,
    todayPosts: 862,
    accent: "primary",
  },
  {
    id: "gossip",
    name: "吃瓜第一线",
    icon: "ri-fire-line",
    desc: "热点速递与理性复盘，先摆事实，再聊感受，理性吃瓜不站队。",
    topics: 9876,
    todayPosts: 1340,
    accent: "accent",
  },
  {
    id: "life",
    name: "生活茶话会",
    icon: "ri-cup-line",
    desc: "租房、通勤、养猫、种花，把日子过得有滋有味的人都在这儿。",
    topics: 15420,
    todayPosts: 1105,
    accent: "secondary",
  },
  {
    id: "work",
    name: "职场唠嗑",
    icon: "ri-briefcase-line",
    desc: "吐槽也好、求助也罢，聊完继续上班，明天依旧是打工人。",
    topics: 8320,
    todayPosts: 720,
    accent: "primary",
  },
  {
    id: "screen",
    name: "影视追剧社",
    icon: "ri-movie-line",
    desc: "追剧、观影、综艺闲聊，不剧透是底线，观点不同也能好好聊。",
    topics: 7310,
    todayPosts: 980,
    accent: "accent",
  },
  {
    id: "hobby",
    name: "兴趣同好圈",
    icon: "ri-gamepad-line",
    desc: "手账、摄影、露营、桌游、数码折腾，找到同好原来这么容易。",
    topics: 6420,
    todayPosts: 615,
    accent: "secondary",
  },
  {
    id: "heart",
    name: "情感树洞",
    icon: "ri-heart-line",
    desc: "想说又不好意思说的话，放这里吧，回帖的人都很温柔。",
    topics: 5940,
    todayPosts: 588,
    accent: "accent",
  },
  {
    id: "food",
    name: "美食瓜田",
    icon: "ri-restaurant-line",
    desc: "今天吃什么永远是世纪难题，来这儿抄作业准没错。",
    topics: 8830,
    todayPosts: 803,
    accent: "primary",
  },
];